module.exports = __webpack_public_path__ + "static/media/flag-korea.b3f86865.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/LanguageFlag/LanguageFlagIcons/flag-korea.svg
// module id = 1132
// module chunks = 1